const SET_IS_MODAL_OPEN = (state, value) => { state.isModalOpen = value }

export default {
  SET_IS_MODAL_OPEN
}
